export const frontmatter = {
  title: "Журнал изменений",
  slug: "changelog",
  category: "О проекте",
  reading_minutes: 2,
  updated: "2026-04-29",
  abstract: "Что и когда добавляли — чтобы пользователь видел эволюцию карты, а не только текущее состояние.",
};

import { Callout, TLDR } from "../../components/mdx";

# Журнал изменений

<TLDR>
История значимых изменений Geobiom — для тех, кто заходит после паузы. Технические коммиты — в [GitHub-репозитории](https://github.com/yungkocherov/mushroom_map/commits/main). Здесь — только то, что меняет опыт пользователя.
</TLDR>

## 2026-04 · Редизайн «Geobiom»

- **Бренд.** Проект переименован: `mushroom-map` → **Geobiom**. Tagline — «лес ленобласти». Домен `geobiom.ru` подключен.
- **Главная страница теперь карта.** Вместо hero-секций с виджетами — карта Ленобласти с sidebar слева.
- **Прогноз грибности (preview).** API `/api/forecast/at` отдаёт детерминированный fixture; ML-модель из сестринского репо `mushroom-forecast` приедет позже и заменит источник без изменений во фронте.
- **Spotlight (⌘K).** Глобальный поиск по видам и топонимам Ленобласти.
- **Реструктуризация навигации.** Четыре раздела: «Карта», «Виды», «Споты», «Методология». Старые URL (`/map`, `/forecast`, `/about`, `/cabinet/spots`, `/guide`) — 301'ы.
- **`/species/:slug` редизайн.** Hero с фото-фоном, двухколоночное тело с сезоном и сродством к лесу.
- **`/methodology` хаб.** Четыре рубрики: источники данных, модель прогноза, о проекте, юридическое.

## 2026-04 · Лесные и геофичи

- **Полигоны Рослесхоза — ~2 млн выделов.** Полное покрытие Ленобласти из ФГИС ЛК.
- **Почвенная карта.** Полигоны Докучаевского ин-та (1:2.5М) — слой и `/api/soil/at` для будущей feature-extractor'ной модели.
- **Водотоки OpenStreetMap.** ~204k линий с расстоянием до воды через KNN.
- **Рельеф Copernicus GLO-30.** DEM/slope/aspect; цветной hillshade-слой с гипсометрией.
- **Районы ЛО.** 18 muni-районов из OSM Overpass.
- **Gazetteer + Natasha NER.** ~21k топонимов; VK-посты привязываются к району текстовым анализом.

## 2026-03 · VK-пайплайн

- **69k постов из ВК-сообществ грибников.** Корпус с 2014 года, четыре стадии обработки.
- **Qwen3.5-9B классификатор фото.** Заменил Gemma 3 12B; 18 видов + 3 ягоды; стабильные prompt-версии в `pipelines/prompts/`.
- **Агрегаты «что сейчас собирают».** На главной и в районах — топ видов с датой и долей.

<Callout type="note" title="Раньше">
Архив более ранних изменений — в git-логе. Если вы попали сюда из закладки и не помните, что было до 2026-03 — это нормально: проект до того момента был в стадии «работает у автора локально», без публичного запуска.
</Callout>
